module.exports = __webpack_public_path__ + "img/slide-2.d053d680.jpg";